$(document).ready(function() {
  
  	if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
 		// some code..
    } else {
      
      $('.product-item').on('mouseenter', function() {
          $(this).find('.quick-view-button-wrap').show();
      });
      $('.product-item').on('mouseleave', function() {
          $(this).find('.quick-view-button-wrap').hide();
      });

    // clear after close
     $('.quick-view-button').fancybox({
         afterClose : function(){
           $('#product-variants').empty();
           $('#product-variants').append('<select id="product-select" name="id"></select>');
           $('#qv-image').attr('src','');
           $('#qv-galleryid').empty();
           $('#qv-right').find('.shopify-product-reviews-badge').remove();
           $('.qv-notify-me').hide();
           $('#qv-right').find('.spr-badge').closest('a').remove();
           $('#qv-notify-me-success').hide();
           $('#qv-sold-out-badge').hide();
         },
       	   openMethod : 'dropIn',
       onActivate:function (){
         var F=$('#show-quick-view');
         $(F).hide();
         var endPos= {};
         endPos.top = ( - 300) + 'px';
        endPos.opacity = 0;

        $(F).css(endPos).show().animate({
            top: '+=300px',
            opacity: 1
        }, {
            duration: 400
        });
       },
   		   openSpeed : 250,
           closeMethod : 'dropOut',
           closeSpeed : 100
       });


    $('.quick-view-button').on('click', function() {
      // google analytics event tracking
      ga('send', 'event', 'Product-qv', 'quick-view-open');
      
      // var review_content=$(this).parents('.product-item').find('.spr-badge').html();
      var review_content=$(this).parents('.product-item').find('.jdgm-widget').html();


     $('.alert').hide();
      $('input[name=quantity]').val('1');
      var handle = $(this).attr('handle');
      var p_ind=0;
      $(this).parents('.product-item').find('.prod-imgs').each(function(){
        var src=$(this).attr('data-imageurl');
        var img_id=$(this).attr('data-imageid');
  //       $.getJSON('/admin/metafields.json?metafield[owner_id]='+$(this).attr('data-imageid')+'&metafield[owner_resource]=product_image',function(res){
  //         var alt='';
  //         for(var i=0;i<res.metafields.length;i++){
  //           if(res.metafields[i].key=='alt'){
  //           	alt=res.metafields[i].value;
  //             break;
  //           }
  //         }
  //         var img_cont='<a  '+(alt!=''?'data-fancybox class="fancybox"':'')+' href="'+(alt!=''?'https://' + alt:'#')+'"><img class="qv-gallery-image thumbnail" id="gallery-image-'+p_ind+'" src="'+src+'" alt="'+alt+'" data-imageid="'+img_id+'"></a>';
  //         $('#qv-galleryid').append(img_cont);

  //         p_ind++;
  //       })

        var alt=$(this).attr('alt');
        var img_cont='<a  class="qv-gallery-image-a"'+ (alt.match('^vimeo') ? 'data-fancybox class="fancybox"' : '') + (alt.match('^vimeo') ? '' : 'data-zoom="'+src+'"') + ' href="'+ (alt.match('^vimeo') ? 'https://' + alt : '#') +'"><img class="qv-gallery-image thumbnail" id="gallery-image-'+p_ind+'" src="'+src+'" alt="'+alt+'" data-imageid="'+img_id+'"></a>';
        $('#qv-galleryid').append(img_cont);
        p_ind++;

      });
      //.promise().done(function(){
  //       	console.log(JSON.stringify(images))
  //     	if (images.length > 1) {

  //         }
  //   });
      $.getJSON('/products/' + handle + '.js', function(product) {
        var prod=product;


  //       product.options[0].values=['abcd','cdf'];
        $('#qv-title').html('<a href="'+product.url+'"><h1>'+ product.title + '</h1></a>');
        $('#qv-des').html('<p>' + product.description + '</h1>');
        $('#qv-detail').attr('href', product.url);
        if (product.available == false ) {
         $('#qv-unavailable').removeClass('qv-hidden'); 
        }
        if (product.inventory_quantity == 0 ) {
         $('#qv-sold-out').removeClass('qv-hidden');
        }

        $('#qv-image').attr('src', product.featured_image ).attr('class', 'zoomImg');


        $('.qv-gallery-image-a').click(function(e){
          	e.preventDefault();
        	$('#qv-image').attr('src', $(this).find('.qv-gallery-image').attr('src'));  
        });
        
//         $('.qv-gallery-image').click(function(){
//           $('#qv-image').attr('src', $(this).attr('src'))
//         });

        //shopify product reviews

          // $('#qv-title').after('<a href="'+product.url+'/#reviews"><span class="shopify-product-reviews-badge" data-id="'+product.id+'">'+review_content+'</span></a>');
        $('#qv-title').after('<a href="'+product.url+'/#reviews"><span class="shopify-product-reviews-badge" data-id="'+product.id+'">'+review_content+'</span></a>');

        // option selected callback on load
        var selectCallback = function(variant, selector) {
          if (variant) {
            if (variant.available) {
              // Selected a valid variant that is available.
              $('.qv-cartbtn').removeClass('qv-hidden').removeAttr('disabled').val('Add to Cart').fadeTo(200,1);
              $('#buy-now-link').attr("href","https://www.athorganics.com/cart/"+variant.id+":1");
              $('.buy-now-button-wrapper').show();
            } else {
              // Variant is sold out.
              $('.qv-cartbtn').val('Sold Out').addClass('qv-hidden').attr('disabled', 'disabled').fadeTo(200,0.5);
              $('.qv-cartbtn').hide();
              $('.buy-now-button-wrapper').hide();
              $('.qv-notify-me').show();
              $('.qv-notify-me form').show();
              $('#notify-variant').val(variant.id);
              $('#qv-sold-out-badge').show();
            }
            // Whether the variant is in stock or not, we can update the price and compare at price.
            if ( variant.compare_at_price > variant.price ) {
              $('#qv-price').html('<span class="product-price on-sale">'+ Shopify.formatMoney(variant.price, "") +'</span>'+'&nbsp;<s class="product-compare-price">was '+Shopify.formatMoney(variant.compare_at_price, "")+ '</s>');
            } else {
              $('#qv-price').html('<span class="product-price">'+ Shopify.formatMoney(variant.price, "") + '</span>' );
            }
          } else {
            // variant doesn't exist.
            $('.qv-cartbtn').val('Unavailable').addClass('qv-hidden').attr('disabled', 'disabled').fadeTo(200,0.5);
          }

        }


        // initialize multi selector for product
        jQuery(function($) {
          new Shopify.OptionSelectors("product-select", { product: prod, onVariantSelected: selectCallback });
          if(product.options.length>1){
            $('#qv-quantity').hide();
            var i=0;
            $('#product-variants').find('.single-option-selector').each(function(){
//               if(product.options[i].name=='Title'){
//                   $(this).parents('.selector-wrapper').hide();
//                   return true;
//               }
              $(this).parents('.selector-wrapper').find('label').text(product.options[i].name);
              i++;
            }) 
          }else if(product.options.length==1){
           $('#qv-quantity').closest('.qv-optionrow').hide(); 
           $('#product-variants').find('.single-option-selector').each(function(){
//               if(product.options[0].name=='Title'){
//                   $(this).parents('.selector-wrapper').hide();
//                   return true;
//               }
               if($(this).parents('.selector-wrapper').find('label').size()<=0){
                  $(this).parents('.selector-wrapper').prepend('<label>Quantity</label>')
               }else{
                  $(this).parents('.selector-wrapper').find('label').text('Quantity'); 
               }
              i++;
           }) 
          }
        });
        
			
		  $('.qv-notify-me').off('click').on('click', 'input[type="submit"]', function(e) {
		
  
              $('.qv-notify-me form').hide();
              $('#qv-notify-me-success').show();
              setTimeout(function(){
                $('.fancybox-close-small').click()
              }, 5000);
 
      	
         });	

        
        // listen to notify me and send ajax
//         $('.qv-notify-me input[type="submit"]').off('click').on('click', function(e) {
//           // google analytics event tracking for notify
//           ga('send', 'event', "Product-qv", 'quick-view-notify');
          
//           // validate
          
//           var emailValue = $('.qv-notify-me input[name="email"]').val();
          
//           var testEmail = /^[A-Z0-9._%+-]+@([A-Z0-9-]+\.)+[A-Z]{2,}$/i;
//           if (testEmail.test(emailValue)) {
//             var passed = emailValue;
//           } else {
//             $('.qv-notify-me input[name="email"]').addClass('warning');
//             $('.qv-notify-me input[type="submit"]').prop("disabled", true);
//           }
          
          
//           // grab data
//           var notifyData={
//             a: 'NbQJqU',
//             email: emailValue,
//             variant: 19394619397,
//             platform: 'shopify'
//           };
          
//           // send data
          
// //           e.preventDefault();
// //           $.ajax({
// //             type: 'GET',
// //             url: 'https://a.klaviyo.com/api/v1/catalog/subscribe',
// //             data: notifyData,
// //             dataType: 'jsonp',
// //             success:function(r){
// //             },
// //             error: function(error){
// //               console.log(error);
// //             },
// //           });
//         });
        
        //add to cart function 

        // listen to add to cart send ajax
        $('.qv-cartbtn').off('click').on('click', function(e) {
          // google analytics event tracking
          ga('send', 'event', 'Product-qv', 'quick-view-add');
          
          $('.alert').hide();
          var par={
            id:'',
            quantity:1
          };
         for(var i=0;i<product.variants.length;i++){
            var bool=true;
            for(var j=0;j<$('#product-variants').find('select').size()-1;j++){
              if($('#product-variants').find('select:eq('+j+')').val()!=product.variants[i]['option'+(j+1)]){
                bool=false;
                break;
              }
            }
            if(bool) {
              par={
                id: product.variants[i].id,
                quantity:$('input[name=quantity]').val()
              }
              break;
            }

          }

          e.preventDefault();
          $.ajax({
            url:'/cart/add.js',
            data:par,
            dataType:'json',
            success:function(resp){
              $.getJSON('/cart.js',function(data){
                $('input[type=submit]').val('Added!');
                setTimeout(function(){
                  $('input[type=submit]').val('Add to Cart');
                  $('.fancybox-close-small').click();
                  }, 1500);
                $('a.cart-empty').addClass('cart-link').find('.number-wrapper').removeClass('hide').find('span.number').text(data.item_count);
              });
            },
            error:function(err){
               console.log(err);
            }
          });         

        });

       // clear multi selector
        $('button[data-fancybox-close]').click(function() {
            $('#product-variants').empty();
          $('#product-variants').append('<select id="product-select" name="id"></select>');
          $('#qv-image').attr('src','');
        });

        //hide loader once completed
        $('#loading').hide();

      });

    });

	}
});